var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteLimitReached(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 70,
    viewBox: "0 0 82 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.528 36.7885V61.2243C46.528 62.3369 46.086 63.4039 45.2993 64.1906C44.5126 64.9773 43.4456 65.4193 42.333 65.4193H8.77311C7.66053 65.4193 6.59352 64.9773 5.80681 64.1906C5.0201 63.4039 4.57813 62.3369 4.57812 61.2243V36.7885C4.5815 35.9519 4.83494 35.1354 5.30588 34.444C5.77681 33.7525 6.44374 33.2177 7.22097 32.9081L24.0009 26.1961C24.9976 25.7992 26.1085 25.7992 27.1052 26.1961L43.8852 32.9081C44.6624 33.2177 45.3293 33.7525 45.8002 34.444C46.2712 35.1354 46.5246 35.9519 46.528 36.7885Z",
    stroke: "#0F172A",
    strokeWidth: 4.19499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 57.0234H38.1387",
    stroke: "#0F172A",
    strokeWidth: 4.19499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 48.6406H38.1387",
    stroke: "#0F172A",
    strokeWidth: 4.19499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1387 40.25H12.9688V65.4199H38.1387V40.25Z",
    stroke: "#0F172A",
    strokeWidth: 4.19499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.998,
    cy: 25.5215,
    r: 24.6152,
    fill: "#EA8685",
    fillOpacity: 0.19
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9462 30.6612L58.7678 16.349C58.5894 16.0343 58.3308 15.7726 58.0183 15.5905C57.7059 15.4084 57.3506 15.3125 56.989 15.3125C56.6273 15.3125 56.2721 15.4084 55.9596 15.5905C55.6471 15.7726 55.3885 16.0343 55.2102 16.349L47.0318 30.6612C46.8515 30.9733 46.757 31.3276 46.7578 31.6881C46.7586 32.0486 46.8547 32.4024 47.0363 32.7138C47.218 33.0251 47.4787 33.283 47.7921 33.4611C48.1054 33.6392 48.4604 33.7313 48.8208 33.7281H65.1776C65.5363 33.7277 65.8886 33.633 66.1991 33.4534C66.5097 33.2738 66.7675 33.0156 66.9467 32.7049C67.1259 32.3941 67.2202 32.0417 67.2201 31.683C67.22 31.3242 67.1255 30.9718 66.9462 30.6612Z",
    stroke: "#FD3757",
    strokeWidth: 2.0446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21.4609V25.5501",
    stroke: "#FD3757",
    strokeWidth: 2.0446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29.6406H57.0103",
    stroke: "#FD3757",
    strokeWidth: 2.0446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteLimitReached);
export default __webpack_public_path__ + "static/media/SiteLimitReached.bf91c64ff7617e0a5f201e5dd018a84e.svg";
export { ForwardRef as ReactComponent };